























































































import { Component, Vue } from 'vue-property-decorator'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import BuilderAddButton from '@/components/builder/BuilderAddButton.vue'
import BuilderDefaultContainer from '@/components/builder/BuilderDefaultContainer.vue'
import BuilderSidebar from '@/components/builder/BuilderSidebar.vue'
import BuilderButton from '@/components/builder/BuilderButton.vue'
import BuilderTooltip from '@/components/builder/BuilderTooltip.vue'
import StepsNavigation from './components/StepsNavigation.vue'
import AppExampleChatsList from './components/AppExampleChatsList.vue'
import CommonButton from '@/components/common/CommonButton.vue'
import CommonModal from '@/components/common/CommonModal.vue'
@Component({
  components: {
    BuilderDefaultContainer,
    BuilderTooltip,
    BuilderButton,
    BuilderSidebar,
    AppExampleChatsList,
    StepsNavigation,
    BuilderAddButton,
    CommonButton,
    CommonModal,
  },
  computed: {
    ...mapGetters('buildergpt', ['getCurrentStep', 'getApp']),
  },
  methods: {
    ...mapMutations('buildergpt', ['changeStep']),
    ...mapActions('buildergpt', ['saveData']),
  },
})
export default class BuilderGptStep4 extends Vue {
  getApp!: any
  loaded = true
  viewMode = false
  processing = false

  validationErrors = false
  open = false
  stepData = {
    botLimitType: 1,
    botLimit: 5,
  }
  promoPageName = ''
  getCurrentStep!: number
  saveData!: any

  get position() {
    if (this.$breakpoints.desktop) {
      return 0
    }
    if (this.$breakpoints.tablet) {
      return 100
    }
    if (this.$breakpoints.mobileSmall) {
      return 15
    }
    if (this.$breakpoints.xs) {
      return 95
    }
    return 0
  }

  get isNextStepDisabled() {
    return this.stepData.botLimit < 1 || this.stepData.botLimit > 10
  }

  async confirmStep(): Promise<void> {
    await this.saveData(this.stepData)
    this.$router.push({ path: `/gpt/step/${this.getCurrentStep}` })
  }
  mounted() {
    if (this.getApp.botLimit) {
      this.stepData.botLimit = this.getApp.botLimit
    }
    if (this.getApp.botLimitType) {
      this.stepData.botLimitType = this.getApp.botLimitType
    }
  }
}
